import type { CommunityDetail } from '@pba/react-network';
import { Card, Icon, RichTextRenderer } from 'ui';

export type P = {
  community: CommunityDetail;
};

const Description = ({ community }: P) => (
  <Card title={<Card.Title icon={<Icon icon="document-line" />}>Description</Card.Title>}>
    <RichTextRenderer data={community.htmlDescription} />
  </Card>
);

export default Description;
